<template>
  <div>
    <div class="wallet-box intro-x">
      <img src="@/assets/images/qianbao.png" alt="" />
      <div class="moneyDiv">
        <div class="div1">余额支付</div>
        <div v-if="userInfo" class="div2">
          当前余额：¥ {{ userInfo.fin_invalid + userInfo.fin_valid }}
        </div>
      </div>
    </div>
    <div class="PhoneCode-box intro-x">
      <p>输入支付密码</p>
      <div style="margin-top: 10px">
        <el-input
          v-model="password"
          show-password
          placeholder="请输入密码"
        ></el-input>
        <div class="wangji" @click="isPassword = true">忘记密码</div>
      </div>
    </div>

    <!--    支付密码-->
    <zfPassword v-if="isPassword" :infoData="userInfo" @setCancel="setCancel" />
  </div>
</template>

<script>
import lodash from "lodash";
import Cookies from "js-cookie";
import zfPassword from "../modules/zfPassword";

export default {
  components: {
    zfPassword,
  },
  data() {
    return {
      password: "",
      isPassword:false,
      // 倒计时周期
      // countNum: 60,
      // // 用于倒计时标记，true-正在倒计时
      // countFlag: false,
      // // 定时器
      // intervalBtn: {},
      // btnMsg: "发送验证码",
      // phone: 13825663293,
      // code:'',
    };
  },
  computed: {
    userInfo: function () {
      return JSON.parse(Cookies.get("userInfo"));
    },
  },
  activated() {
    this.password = "";
  },
  methods: {
    setCancel: function (name, value) {
 
        this.isPassword = false;
        if (value) {
          this.userInfo.passcode = value;
        }
        return;
  
    },

    // 倒计时
    countDown() {
      // 设置btn倒计时时显示的信息
      this.btnMsg = null;
      // 更改btn状态
      this.countFlag = !this.countFlag;
      // 设置倒计时
      this.intervalBtn = setInterval(() => {
        if (this.countNum <= 0) {
          // 重置btn提示信息
          this.btnMsg = "发送验证码";

          // 清除定时器
          clearInterval(this.intervalBtn);
          // 更改btn状态
          this.countFlag = !this.countFlag;
          // 重置倒计时状态
          this.countNum = 60;
        }
        // 倒计时
        this.countNum--;
      }, 1000);
    },
    // 获取验证码 --- > 防抖
    sendMobile: lodash.debounce(function () {
      if (this.btnMsg != "发送验证码") {
        return;
      }

      //获取输入手机号码
      let phone = this.phone;
      //正则校验手机号是否合法
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
        this.$message.error("手机号错误");
        return;
      }
      this.countDown();

      if (this.btnMsg === null) {
        return;
      }
    }, 200),
  },
};
</script>
<style lang="scss" scoped>
.wallet-box {
  width: 27.5%;
  min-width: 282px;
  height: 88px;
  padding: 19px 2%;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #1890ff;
  border-radius: 22px;
  margin: 50px auto 30px;
  img {
    width: 48px;
    height: 48px;
    float: left;
  }
  .moneyDiv {
    float: left;
    font-size: 14px;
    margin-left: 20px;
    height: 48px;
    line-height: 24px;
    .div1 {
      color: #333333;
    }
    .div2 {
      color: #999999;
    }
  }
}

.PhoneCode-box {
  width: 27.5%;
  min-width: 282px;
  margin: auto;
  position: relative;
  .wangji {
    position: absolute;
    right: 30px;
    top: 44px;
    color: #1890ff;
    font-size: 12px;
    cursor: pointer;
  }
  .phone-box {
    font-size: 14px;
    color: #333333;
    margin-bottom: 18px;
    .elInput {
      display: inline-block;
      width: calc(100% - 70px - 3%);
      margin-left: 3%;
    }
  }

  .code-box {
    font-size: 14px;
    color: #333333;
    .elInput {
      display: inline-block;
      width: calc(100% - 70px - 5% - 84px);
      margin-left: 3%;
    }
    .code84 {
      width: 84px;
      height: 40px;
      line-height: 40px;
      background: #1890ff;
      font-size: 12px;
      text-align: center;
      color: #fff;
      border-radius: 12px;
      display: inline-block;
      margin-left: 2%;
      cursor: pointer;
    }
    .code84:active {
      background: #49a6fd;
    }
  }
}

.countClass {
  background: #edf1f6 !important;
  color: #788598 !important;
  cursor: no-drop !important;
}
</style>